<template>
  <div class="notice-sentence" v-if="isShowPopup">
    <v-dialog v-model="isShowPopup" />
    <transition-group name="menu-mask">
      <div class="notice-sentence-frame" v-if="isAnimation" :key="1">
        <div class="notice-sentence-upper">
          <div class="notice-sentence-date">{{ selectedNotice.date }}</div>
          <div class="notice-sentence-name">{{ selectedNotice.name }}</div>
        </div>
        <div class="notice-sentence-line" />
        <div class="notice-sentence-under">
          <div class="notice-sentence-detail">{{ selectedNotice.detail }}</div>
        </div>
        <div class="notice-sentence-line" />
        <div class="notice-sentence-detail">{{ '今後とも、おかずかんを\nよろしくお願いいたします。' }}</div>
      </div>
      <div class="notice-sentence-button" v-if="isAnimation" :key="2">
        <Button text="とじる" @click="clickClose()" />
      </div>
    </transition-group>
  </div>
</template>

<script>
import Button from '@/parts/Button';

export default {
  name: 'NoticeSentence',
  components: {
    Button
  },
  props: {
    selectedNotice: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isShowPopup: false,
      isAnimation: false
    };
  },
  methods: {
    clickClose() {
      this.$emit('clickClose');
    }
  },
  watch: {
    selectedNotice(n) {
      if (n) {
        this.$nextTick()
          .then(() => {
            this.isShowPopup = true;
          })
          .then(() => {
            this.isAnimation = true;
          });
      } else {
        this.isShowPopup = false;
        this.isAnimation = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notice-sentence {
  &-black {
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    z-index: 10000;
  }

  &-frame {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 90vw;
    max-width: 500px;
    height: 70vh;
    background-color: white;
    border-radius: 10px;
    color: #666666;
    outline: 3px solid#ffd295;
    padding: 8px 4px;
    z-index: 100000;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-upper {
    padding: 16px;
  }

  &-line {
    border-bottom: 2px dashed #ffd295;
  }

  &-detail {
    margin: 5%;
    white-space: pre-wrap;
  }

  &-button {
    position: fixed;
    bottom: 5vh;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 100000;
  }
}

.menu-mask-enter-active {
  animation: bounce-in 0.2s;
}
@keyframes bounce-in {
  0% {
    transform: scale(0.6);
  }
  70% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
</style>
